import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'SurveyPage',
  setup(__props) {

const messages = ref([
  { id: '1', initials: 'JS', title: 'John Smith', time: '2h' },
  { id: '2', initials: 'ML', title: 'Mary Lane', time: '1d' },
])

return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("h1", null, "survey page", -1)),
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("p", null, "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Amet, quia!", -1)
        ]))]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})